(function($, App, Utils, Components){
    'use strict';

    const logger = new Logger("Skin");

    Components.create('Skin', {

    Selectors: {
        Body: "body"
    },

    bindEvents: () => {
        App.Window.on('scroll', function(e) {
           var headerHeight = $('header').position().top + $('header').height() - window.scrollY;
           Components.Skin.fixSkin(headerHeight >= 0 ? headerHeight : 0);
        });
        $(Components.Skin.Selectors.Body).on('click', function (e) {
            var skinLink = $(Components.Skin.Selectors.Body).data("skin-link");
            if (e.target == e.currentTarget) {
                window.location = skinLink;
            }
        });
    },

    fixSkin: (headerHeight) => {
        $(Components.Skin.Selectors.Body).css('background-position-y', headerHeight);
    },

    init: () => {
        if ($('header').length) {
            var headerHeight = $('header').position().top + $('header').height();
            Components.Skin.fixSkin(headerHeight);
            Components.Skin.bindEvents();
        } else {
            logger.warn("Header element not found. Skin component initialization skipped.");
        }
    }
    });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components
);

